
    import { Component, Vue } from 'vue-property-decorator';
    import InputText from '@/components/form/Input-text.vue';
    import {ApiRepository} from '@/api';


    @Component({
        components: {
            InputText,
        },
    })
    export default class NewPassword extends Vue {
        private password = '';
        private passwordConfimation = '';

        private async onSubmit(event: any) {
            event.preventDefault();
            const token = this.$route.params.token;

            this.$validator.validate().then((valid) => {
                if (valid && this.password === this.passwordConfimation) {
                    ApiRepository.postNewPassword(this.password, this.passwordConfimation, token);
                } else {
                    this.$notify({group: 'auth', type: 'warning', text: 'Heslá sa nezhodujú'});
                }
            });
        }
    }
